import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import rootReducer from "./reducers/rootReducer";
import { AppApi } from "./api/AppApi";
import { baseApi } from "./api/BaseApi";

const base_url = process.env.REACT_APP_BASE_API_URL || "no_base_url_provided";

interface MiddlewareType {
  thunk: {
    extraArgument: {
      api: (state: any) => AppApi;
    };
  };
}

const store = configureStore({
  reducer: {
    root: rootReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware<MiddlewareType>({
      thunk: {
        extraArgument: {
          api: (state) => new AppApi(state, base_url),
        },
      },
    }).concat(baseApi.middleware),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

export default store;
